<template>
  <v-container class="error-page d-flex flex-column align-center justify-center">
    <v-card class="error-card pa-10 text-center" max-width="500">
      <v-icon size="80" color="red">mdi-alert-circle-outline</v-icon>
      <h1 class="mt-5">Ошибка</h1>
      <p class="mt-2">Такой страницы не существует</p>
      
    </v-card>
  </v-container>
</template>

<script>
export default {
}
</script>

<style scoped>
h1 {
  font-weight: bold;
}

.error-page {
  min-height: 100vh;
}

@media (max-width: 480px) {
  .error-page {
    min-height: 100svh;
  }

  .error-card {
    width: 100%;
    padding: 24px 16px !important;
  }

  .error-card h1 {
    font-size: 28px;
  }
}
</style>
